import { types } from 'mobx-state-tree';
import { formatDate } from 'globals/utils';
import { Currency, CurrencyInstance, CurrencyProps } from './currency';

export enum InfoBoxType {
  TIMESTAMP = 'timestamp',
  STRING = 'string',
  CURRENCY = 'currency',
}

export const InfoBoxTypes: InfoBoxType[] = Object.values(InfoBoxType);

export interface InfoBoxProps {
  type: InfoBoxType;
  caption: string;
  value: string | number | CurrencyProps;
}

export const InfoBox = types
  .model({
    type: types.enumeration(InfoBoxTypes),
    caption: types.string,
    value: types.union(types.string, types.number, Currency),
  })
  .views((self) => ({
    displayValue(): string {
      const { type, value } = self;
      switch (type) {
        case InfoBoxType.STRING:
          return value as string;
        case InfoBoxType.TIMESTAMP:
          return formatDate(value as number, true);
        case InfoBoxType.CURRENCY:
          return (value as CurrencyInstance).displayValue();
        default:
          return '';
      }
    },
  }));
